export enum RiskAssessmentReportStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  INVALIDATED = "INVALIDATED",
  UNDER_REVIEW = "UNDER_REVIEW",
}
